import { useLocation } from "react-router-dom";

// This route intentionally throws to defer rendering to the global ErrorBoundary
export default function AuthError(): React.JSX.Element {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const message =
    params.get("error") ||
    params.get("error_description") ||
    params.get("message") ||
    params.get("code") ||
    "Authentication failed";

  throw new Error(message);
}
